import React from 'react';
import NotificationForm from './form';
import {normalizer} from './pipeline';
import {addNotificationItem} from '../../modules/Api';
import {notification} from 'antd';

class AddNotification extends React.Component {
    constructor() {
        super();
        this.state = {
            submitted: false
        }

    }
    submit(values) {
        if(this.state.submitted){
            return;
        }
        this.setState({submitted: true});
        const formData = normalizer(values);
        addNotificationItem(formData, () => {
            notification.open({
                message: `اعلان ارسال شد!`,
                description: `اعلان ثبت شد. می توانید آن را در لیست اعلان ها مشاهده کنید.`
            });
            this.setState({submitted: false});
        });
    }
    render() {
        return (<div><NotificationForm submit={this.submit.bind(this)} submitted={this.state.submitted}/></div>);
    }
}

export default AddNotification;


// WEBPACK FOOTER //
// ./src/containers/Notification/add.js